import Vue from 'vue';
import Router from 'vue-router';

import { loginRoute } from './login';
import { authGuard } from './auth.guard';

import userRoutes from '@/pages/Users/router';
import settingsRoute from '@/pages/Settings/router';
import dashboardRoute from '@/pages/Dashboard/router';
//#region Imports
import companyRoute from '@/pages/Companies/router';
import aes_envelopeRoute from '@/pages/Aes_envelopes/router';
import companylocationRoute from '@/pages/Companylocations/router';
import aes_envelopestatRoute from '@/pages/Aes_envelopestats/router';
import envelopestatusRoute from '@/pages/Envelopestatuses/router';
import businessRoute from '@/pages/Businesses/router';
import attributeRoute from '@/pages/Attributes/router';
import drugDatabaseRoute from '@/pages/DrugDatabase/router';
import casesRoute from '@/pages/Cases/router';

//#endregion Imports

Vue.use(Router);

export const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    userRoutes,
    dashboardRoute,
    settingsRoute,
    loginRoute,
    //#region Routes
    companyRoute,
    aes_envelopeRoute,
    companylocationRoute,
    aes_envelopestatRoute,
    envelopestatusRoute,
    businessRoute,
    attributeRoute,
    drugDatabaseRoute,
    casesRoute
    //#endregion Routes
  ]
});

authGuard(router);

export default router;
